import { render, staticRenderFns } from "./ToDoLi.vue?vue&type=template&id=4f2b6dc0&scoped=true"
import script from "./ToDoLi.vue?vue&type=script&lang=js"
export * from "./ToDoLi.vue?vue&type=script&lang=js"
import style0 from "./ToDoLi.vue?vue&type=style&index=0&id=4f2b6dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2b6dc0",
  null
  
)

export default component.exports